import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import SimilarProjects from './../Elements/SimilarProjects';
import Banner from './../Elements/Banner';
import ReactPlayer from 'react-player';
const myVideo = '/assets/media/video/vid_1.mp4';

var bnrimg = require('./../../images/banner/5.jpg');

class ProjectDetail extends React.Component {

    constructor(props) {
        super(props);
        this.state = { showModal: false };
    }

    render() {
        const { showModal } = this.state;
        return (
            <>
                <Header />
                <div className="page-content">
                    <Banner title="Helping you and your house become better acquainted." pagename="Project Detail" bgimage={bnrimg} />

                    {/* SECTION CONTENT START */}
                    <div className="section-full p-tb80 inner-page-padding">
                        <div className="container">
                            <div className="project-detail-outer">
                                <div className="m-b0">
                                    <div className="row">
                                        <div className="col-md-4 col-sm-4">
                                            <div className="project-detail-pic m-b30">
                                                <div className="mt-media">
                                                    <img src={require('./../../images/projects/portrait/pic7.jpg')} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-4">
                                            <div className="project-detail-pic m-b30">
                                                <div className="mt-media">
                                                    <img src={require('./../../images/projects/portrait/pic4.jpg')} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-4">
                                            <div className="project-detail-pic m-b30">
                                                <div className="mt-media">
                                                    <img src={require('./../../images/projects/portrait/pic5.jpg')} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="m-b30">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="product-block">
                                                <div className="row">
                                                    <div className="col-md-12 m-b10">
                                                        <h4 className="text-uppercase font-weight-600 m-b10">Date</h4>
                                                        <p>April 10, 2023</p>
                                                    </div>
                                                    <div className="col-md-12 m-b10">
                                                        <h4 className="text-uppercase font-weight-600 m-b10">Client</h4>
                                                        <p>Meezan Bank head office, Islamabad</p>
                                                    </div>
                                                    <div className="col-md-12 m-b10">
                                                        <h4 className="text-uppercase font-weight-600 m-b10">Project type</h4>
                                                        <p>All tower wooden cabinet, Some IT work and 12th floor</p>
                                                    </div>
                                                    <div className="col-md-12 m-b10">
                                                        <h4 className="text-uppercase font-weight-600 m-b10">Location</h4>
                                                        <p>Meezan Tower Islamabad is located at Ibn-e-Sina Rd, Islamabad</p>
                                                    </div>
                                                    <div className="col-md-12 m-b10">
                                                        <h4 className="text-uppercase font-weight-600 m-b10">Year</h4>
                                                        <p>2023</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <div className="mt-box">
                                                <div className="mt-thum-bx mt-img-overlay1 mt-img-effect yt-thum-box">
                                                    <img src="/assets/media/images/thomb.jpg" alt="Project video" />
                                                    <button type="button" className="play-now" onClick={() => this.setState({ showModal: true })}>
                                                        <i className="icon fa fa-play" />
                                                        <span className="ripple" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="project-detail-containt">
                                    <div className="bg-white text-black">
                                        <h3 className="font-weight-600">Creating a sustainable future through building preservation, green
                                            CEO & Architecture, and smart design</h3>
                                        <p> Designers think everything done by someone else is awful, and that they could do it better themselves, which explains why I designed my own living room carpet, I suppose. the
                                            CEO & Architect represents neither a Dionysian nor an Apollinian condition: here it is the mighty act of will, the will which moves mountains, the intoxication of the strong will, which demands artistic expression. The most powerful men have always inspired the
                                            CEO & Architects; the
                                            CEO & Architect has always been influenced by power.</p>
                                        <p>Our Services: Precision in Every Project
                                            We specialize in delivering comprehensive construction solutions with a distinct focus on interior excellence. Our expertise ensures every detail is crafted to perfection.
                                            Interior Construction & Renovation: Complete interior build-outs, remodeling, and space reconfiguration for homes, offices, and retail spaces.
                                            Finish Carpentry & Millwork: Custom cabinets, built-in furniture, trim, and detailed woodwork that define luxury and functionality.
                                            Commercial Fit-Outs: Efficient and compliant construction of office interiors, retail stores, and hospitality venues.
                                            Residential Development: Thoughtful construction and renovation of living spaces, from single rooms to whole-house projects.
                                            Project Management: A unified command center for your project, coordinating all phases, timelines, and vendors with precision. </p>
                                        <div className="m-b0">
                                            <div className="mt-divider divider-1px  bg-black"><i className="icon-dot c-square" /></div>
                                        </div>
                                        <ul className="social-icons social-square social-darkest m-b0">
                                            <li><NavLink to={"#"} className="fa fa-facebook" /></li>
                                            <li><NavLink to={"#"} className="fa fa-twitter" /></li>
                                            <li><NavLink to={"#"} className="fa fa-linkedin" /></li>
                                            <li><NavLink to={"https://www.instagram.com/buildcoassociates"} className="fa fa-instagram" /></li>
                                            <li><NavLink to={"#"} className="fa fa-youtube" /></li>
                                            <li><NavLink to={"#"} className="fa fa-whatsapp" /></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* SECTION CONTENT END  */}
                    <SimilarProjects />
                </div>

                {/* React-controlled Video Modal */}
                {showModal && (
                    <div
                        style={{
                            position: 'fixed', inset: 0, zIndex: 9999,
                            background: 'rgba(0,0,0,0.85)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                        }}
                        onClick={() => this.setState({ showModal: false })}
                    >
                        <div
                            style={{ position: 'relative', width: '800px', maxWidth: '95vw' }}
                            onClick={e => e.stopPropagation()}
                        >
                            <button
                                onClick={() => this.setState({ showModal: false })}
                                style={{
                                    position: 'absolute', top: '-40px', right: 0,
                                    background: 'none', border: 'none',
                                    color: '#fff', fontSize: '32px', cursor: 'pointer', zIndex: 10
                                }}
                            >&times;</button>
                            <ReactPlayer
                                url={myVideo}
                                playing={showModal}
                                controls
                                width="100%"
                                height="450px"
                            />
                        </div>
                    </div>
                )}

                <Footer />
            </>
        );
    };
};

export default ProjectDetail;